module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAABRklEQVQoU3XQzStEcRTG8e/5ea3ZmC07kSIU7thZ+AOsNImNicyKnVIohbK2kHuVvJQFC3sra4PNZEGKvCyJ5D330ZWRzPgtf6fPeTqPAXiL6sDhA+WI5UzapqP/Qs9afbU7WHWO5M0zx/EytoCLzBDDmOkvMs9XVsV07w/YcTRs2FRp7I4VfSEbywOJQOe3L9Sdjthrblgzr7J4OWeZIavMB76mBC1PcbqPkvbmBdoJxaSD8UzauvLA19GB5hD1sVKSD2/UOmM7FH3OGAWaEOu5Iiy3wQs0gUiZkf2IEr4RcOgcK4jL6KYf8DvaC7QbiuFv1Fkd5/r8nrWovf/AVayEmscnKsJibg7S9t7qq8QZJwVBwtesoDFXRJSeWFSzHBsFAZK1LbFgoiqEHiuizkK25OgtDKKVkiUCZmSkBHc4+vcHbe8T29GGuH9n0w4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/url.png
// module id = Uq58
// module chunks = 1